export default __webpack_public_path__ + "static/media/test-avatar.4a1626a4.png";